export default __webpack_public_path__ + "static/media/user_orange.b72b318e.svg";